import { SliceZone } from '@prismicio/react';
import { Layout } from '../../components/core';
import { PageLoading } from '../../components/page';
import { SkillTransition } from '../../content/skill/components/SkillTransition';
import { components as sliceComponents } from '../../content/skill/components/slice';
import { useSkillContext } from '../../contexts';
import { usePrevious } from '../../utils/usePrevious';
import { SelfCareQuizLanding } from './SelfCareQuizLanding';
import type { SliceContext } from '../../content/skill/components/skillTypes';

export const SelfCareQuizSlides = (): JSX.Element => {
  const { skill, slideCount, slideNumber } = useSkillContext();
  const previousSlideNumber = usePrevious(slideNumber) ?? 0;

  if (!skill) {
    // Don't render while the skill context is initializing.
    return <PageLoading pageName="quiz" />;
  }

  const isGoingBack = slideNumber < previousSlideNumber;

  return (
    <Layout.View
      aria-label="Self Care Quiz slide deck"
      flex={1}
      position="relative"
      role="region"
      testID="self-care-quiz-slides"
    >
      <SkillTransition
        key={1}
        slideCount={slideCount}
        slideNumber={1}
        visible={slideNumber === 1}
        back={isGoingBack}
      >
        <SelfCareQuizLanding isVisible={slideNumber === 1} skill={skill} />
      </SkillTransition>

      {skill.data.slices.map((slice, index) => {
        // +2 offsets it to 1-index based and accounts for the landing page.
        const iterationSlideNumber = index + 2;

        const isVisible = slideNumber === iterationSlideNumber;

        const context: SliceContext = {
          isVisible,
          moduleId: module.id,
          questions: undefined,
          skillId: skill.id,
          slideIndex: iterationSlideNumber,
        };

        return (
          <SkillTransition
            key={iterationSlideNumber}
            slideCount={slideCount}
            slideNumber={iterationSlideNumber}
            visible={isVisible}
            back={isGoingBack}
          >
            <SliceZone context={context} slices={[slice]} components={sliceComponents} />
          </SkillTransition>
        );
      })}
    </Layout.View>
  );
};
